import { render, staticRenderFns } from "./RejectionConfirmationModal.vue?vue&type=template&id=6bb617ed&scoped=true"
import script from "./RejectionConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RejectionConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./RejectionConfirmationModal.vue?vue&type=style&index=0&id=6bb617ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb617ed",
  null
  
)

export default component.exports